import { GET } from "../../../utils/fetcher";
export const FETCH_FORM_BEGIN = "FETCH_FORM_BEGIN";
export const FETCH_FORM_SUCCESS = "FETCH_FORM_SUCCESS";
export const FETCH_FORM_FAILURE = "FETCH_FORM_FAILURE";

export const fetchFormsBegin = () => ({
	type: FETCH_FORM_BEGIN
});

export const fetchFormsSuccess = ({ data }) => ({
	type: FETCH_FORM_SUCCESS,
	payload: { data }
});

export const fetchFormsFailure = error => ({
	type: FETCH_FORM_FAILURE,
	payload: error
});

export function fetchForms({ organizationId }, signal) {
	return dispatch => {
		dispatch(fetchFormsBegin());
		return GET(`/bo/organizers/${organizationId}/forms/`, false, signal)
			.then(response => {
				return { data: response.data };
			})
			.then(res => {
				dispatch(fetchFormsSuccess(res));
				return res;
			})
			.catch(error => {
				dispatch(fetchFormsFailure(error));
			});
	};
}
